module.exports = __webpack_public_path__ + "img/Flag_of_Malawi.6ae05cd6.svg";